var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBookMark = function SvgIconBookMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 .667h8v10L4 9.332l-4 1.333v-10Z",
    fill: "#4F52C3"
  })));
};
export default SvgIconBookMark;